// local
// Routes components
import Monitor from 'app/ui/pages/monitor/Monitor';
import ConfirmDelivery from 'app/ui/pages/confirmDelivery/ConfirmDelivery';
import EditConfirmDelivery from 'app/ui/pages/editConfirmDelivery/EditConfirmDelivery';
import Clients from 'app/ui/pages/clients/Clients';
import Accounts from 'app/ui/pages/accounts/Accounts';
import Patients from 'app/ui/pages/patients/Patients';
import PatientDetails from 'app/ui/pages/patientDetail/PatientDetails';
import Devices from 'app/ui/pages/devices/Devices';
import NotFound from 'app/ui/pages/notfound/NotFound';
import Suppliers from 'app/ui/pages/suppliers/Suppliers';
import RequestDelivery from 'app/ui/pages/requestDelivery/RequestDelivery';
import Reports from 'app/ui/pages/reports/Reports';
// menu icons
import icMenuReport from 'app/_assets/img/ic_menu_report.png';
import icMenuConfirmDelivery from 'app/_assets/img/ic_menu_confirm_delivery.png';
import icMenuMonitor from 'app/_assets/img/ic_menu_monitor.png';
import icMenuRequestDelivery from 'app/_assets/img/ic_menu_request_delivery.png';
import icMenuPatient from 'app/_assets/img/ic_menu_patient.png';
import icMenuDevice from 'app/_assets/img/ic_menu_device.png';
import icMenuUser from 'app/_assets/img/ic_menu_user.png';
import icMenuSupplier from 'app/_assets/img/ic_menu_supplier.png';
import icMenuClient from 'app/_assets/img/ic_menu_client.png';
// features
import FEATURES from 'salvus-shared/lib/features';
// permissions
import checkFeatureByUser from 'app/lib/permissions';

const ROUTES = [
    {
        exact: true,
        path: '/confirm-delivery',
        component: ConfirmDelivery,
        feature: FEATURES.LIST_CONFIRM_DELIVERY,
        title: 'Confirmar Entregas',
        image: icMenuConfirmDelivery,
    },
    {
        exact: true,
        path: '/',
        component: Monitor,
        feature: FEATURES.OXIGEN_BY_PATIENT,
        title: 'Monitoramento',
        image: icMenuMonitor,
    },
    {
        exact: true,
        path: '/request-delivery',
        component: RequestDelivery,
        feature: FEATURES.LIST_PENDING_DELIVERY,
        title: 'Solicitar Entregas',
        image: icMenuRequestDelivery,
    },
    {
        exact: true,
        path: '/edit-confirm-delivery',
        component: EditConfirmDelivery,
        feature: FEATURES.LIST_EDIT_CONFIRM_DELIVERY,
    },
    {
        exact: true,
        path: '/clients',
        component: Clients,
        feature: FEATURES.LIST_CLIENT,
        title: 'Clientes',
        image: icMenuClient,
    },

    {
        exact: true,
        path: '/accounts',
        component: Accounts,
        feature: FEATURES.LIST_ACCOUNT,
        title: 'Usuários',
        image: icMenuUser,
    },
    {
        exact: true,
        path: '/patients',
        component: Patients,
        feature: FEATURES.LIST_PATIENT,
        title: 'Pacientes',
        image: icMenuPatient,
    },
    {
        path: '/patients/:id',
        component: PatientDetails,
        feature: FEATURES.VIEW_PATIENT,
    },
    {
        exact: true,
        path: '/devices',
        component: Devices,
        title: 'Dispositivos',
        image: icMenuDevice,
        feature: FEATURES.LIST_DEVICE,
    },
    {
        exact: true,
        path: '/suppliers',
        component: Suppliers,
        title: 'Fornecedores',
        image: icMenuSupplier,
        feature: FEATURES.LIST_SUPPLIER,
    },
    {
        exact: false,
        path: '/reports',
        component: Reports,
        title: 'Relatórios',
        image: icMenuReport,
        feature: FEATURES.OXIGEN_USAGE_REPORT,
    },
    {
        exact: false,
        path: '*',
        component: NotFound,
    },
];

function isRouteVisible(route, account) {
    return route.path === '*' || checkFeatureByUser(route.feature, account);
}

function isMenuVisible(route, account) {
    return route.title !== undefined && checkFeatureByUser(route.feature, account);
}

export function getRoutes(account) {
    return ROUTES.filter(r => isRouteVisible(r, account));
}

export function getMenu(account) {
    return ROUTES.filter(r => isMenuVisible(r, account));
}
